import React from 'react';
import { connect } from 'react-redux';
import { loadUserRecommendations } from 'components/recommendation/actions';
import { isEqual as sameAddress } from 'shared/models/address';
import { H5 } from 'scy/text';
import { uppercase } from 'scy/text/styles.mod.scss';
import margin from 'scy/margin.mod.scss';
import Recommendations from '../recommendation';
import BrowseMore from 'components/browseMore';

const SLIDER_BREAKPOINTS = [
  {
    breakpoint: 1500,
    settings: { slidesToShow: 6, slidesToScroll: 6 }
  },
  {
    breakpoint: 1400,
    settings: { slidesToShow: 5, slidesToScroll: 5 }
  },
  {
    breakpoint: 1200,
    settings: { slidesToShow: 4, slidesToScroll: 4 }
  },
  {
    breakpoint: 1100,
    settings: { slidesToShow: 3, slidesToScroll: 3 }
  },
  {
    breakpoint: 420,
    settings: { slidesToShow: 2, slidesToScroll: 2 }
  }
];

class EmptyList extends React.Component {
  componentDidMount() {
    const recs = this.props.recs || [];
    if (!recs.length) this.loadRecs();
  }

  componentDidUpdate(prevProps) {
    const addressHasChanged = !sameAddress(
      prevProps.address,
      this.props.address
    );
    const prevUser = prevProps.user || {};
    const nextUser = this.props.user || {};
    const userHasChanged = prevUser.objectId !== nextUser.objectId;
    if (addressHasChanged || userHasChanged) this.loadRecs();
  }

  loadRecs() {
    if (!this.props.recsLoading) this.props.loadUserRecommendations();
  }

  render() {
    const { children, user, recs, recsLoading } = this.props;

    return (
      <div className={margin.sm}>
        {children}

        {!!recs && !!recs.length && !recsLoading && (
          <>
            <H5
              marginClass={`${margin.top_0} ${margin.bottom_sm}`}
              className={uppercase}
            >
              Top Picks for {user && user.firstname ? user.firstname : 'You'}
            </H5>
            <div className={margin.bottom_md}>
              <Recommendations
                link={true}
                list={recs}
                responsive={SLIDER_BREAKPOINTS}
              />
            </div>
          </>
        )}

        <BrowseMore narrow />
      </div>
    );
  }
}

EmptyList.defaultProps = {
  children: null
};

const ConnectedEmptyList = connect(
  state => ({
    address: state.address,
    user: state.login.user,
    recs: state.recommendation.userRecommendations,
    recsLoading: state.recommendation.loadingUserRecommendations
  }),
  { loadUserRecommendations }
)(EmptyList);

export default ConnectedEmptyList;
